import { render, staticRenderFns } from "./IftttOverview.vue?vue&type=template&id=8cbe03ae&scoped=true"
import script from "./IftttOverview.vue?vue&type=script&lang=js"
export * from "./IftttOverview.vue?vue&type=script&lang=js"
import style0 from "./IftttOverview.vue?vue&type=style&index=0&id=8cbe03ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbe03ae",
  null
  
)

export default component.exports